import React from 'react';

function ManualScoredRaceSeriesResult({ data }) {
  // Extract all unique event IDs from all participants' scores
  const allEventIds = Array.from(
    new Set(
      data.flatMap(seriesClass => 
        seriesClass.participants.flatMap(participant => 
          Object.keys(participant.scores).map(key => participant.scores[key].eventId)
        )
      )
    )
  ).sort();

  return (
    <div>
      {data.map((seriesClass) => {
        // Sort participants by total score in descending order
        const sortedParticipants = [...seriesClass.participants].sort(
          (a, b) => b.total - a.total
        );

        return (
          <div key={seriesClass.classId} className="rsultTable newTbl">
            <div className="d-flex justify-content-end p-2"></div>
            <div>
              <h5 style={{ marginLeft: "15px" }}>{seriesClass.className}</h5>
              <table cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th
                      className="tal"
                      style={{
                        textAlign: "left",
                        paddingLeft: "15px",
                        width: "30%",
                      }}
                    >
                      Drivers
                    </th>
                    
                        {allEventIds.map((eventId, index) => {
                          const scoreKey = Object.keys(sortedParticipants[0].scores).find(
                            key => sortedParticipants[0].scores[key].eventId === eventId
                          );
                          const score = scoreKey ? sortedParticipants[0].scores[scoreKey] : null;

                          return (
                            <th
                              key={eventId}
                              className="tar"
                              style={{
                                textAlign: "right",
                                width: "10%",
                                ...(index === allEventIds.length - 1 && {
                                  paddingRight: "15px",
                                }),
                              }}
                            >
                              {score?.eventName || "-"}
                            </th>
                          );
                        })}

                    {/* {allEventIds.map((eventId, index) => (
                      <th
                        key={eventId}
                        className="tar"
                        style={{
                          textAlign: "right",
                          width: "10%",
                          ...(index === allEventIds.length - 1 && {
                            paddingRight: "15px",
                          }),
                        }}
                      >
                        R{index + 1}
                      </th>
                    ))} */}
                    <th
                      className="tar"
                      style={{
                        textAlign: "right",
                        paddingRight: "15px",
                        width: "10%",
                      }}
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedParticipants.map((participant, idx) => (
                    <tr key={idx}>
                      <td
                        className="tal"
                        style={{ textAlign: "left", paddingLeft: "15px" }}
                      >
                        {participant.name}
                      </td>
                      {allEventIds.map((eventId) => {
                        const scoreKey = Object.keys(participant.scores).find(
                          key => participant.scores[key].eventId === eventId
                        );
                        const score = scoreKey ? participant.scores[scoreKey] : null;
                        
                        return (
                          <td
                            key={eventId}
                            className="tar"
                            style={{ textAlign: "right" }}
                          >
                            {score ? score.points : 0}
                          </td>
                        );
                      })}
                      <td
                        className="tar"
                        style={{ textAlign: "right", paddingRight: "15px" }}
                      >
                        <b>{participant.total}</b>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ManualScoredRaceSeriesResult;